module.exports = __webpack_public_path__ + "img/DSC_0087.0290497d.jpg";